import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const tournamentMedalsContainer = style({
  display: 'grid',
  gap: space.s16,
  gridTemplateColumns: `repeat(3, 1fr)`,
  ...responsiveStyle({
    mobile: {
      gridTemplateColumns: `repeat(1, 1fr)`,
    },
    tablet: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    desktop: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  }),
});

export const tournamentMedalContainer = style({
  display: 'flex',
  flexDirection: 'column',
  padding: `${space.s12}px ${space.s16}px`,
  border: `1px solid ${themeVars.container.border.default}`,
  borderRadius: borderRadius.r12,
  gap: space.s12,
});

export const tournamentMedalHeader = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
  ...typography['labelLg'],
});
export const tournamentMedalRewardsContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
});
export const tournamentMedalRewardItem = style([
  typography['labelSm'],
  {
    width: 'fit-content',
    backgroundColor: themeVars.badge.primary.background.idle,
    color: themeVars.badge.foreground.primary,
    padding: `${space.s4}px ${space.s8}px`,
    borderRadius: borderRadius.r8,
  },
]);
